import React, {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from "react";
import ConfirmAlertModal from "../../Components/Modals/confirmAlertModal";
import GolbalSearch from "../utility/common/helpers/GolbalSearch";
import { handleExport1 } from "../utility/data/export/GlobalExport";
import { Row, Col, Container } from "react-bootstrap";
import GlobalColumnDefinations, { getHeader_FieldName } from "../utility/grid/definitions/AgGridDefination";
import Toaster, { showSuccess as showSuccessToast, showWarning } from "../utility/ui/notifications/Toaster";
import GridMaster from "../utility/grid/GridMaster";
import UnifiedActionRenderer from "../utility/grid/renderers/ActionRenderers/UnifiedActionRenderer";
import Export_blue from "../../icons/Export_blue.svg";
import ExportIcon from "../../icons/ExportIcon.svg";
import { deleteDropdownValue, getAllDropdown } from "../../Services/dropdown-services";
import AddEditDropdownValueMaster from "./AddEditDropdownValueMaster";
import { refreshDropdown } from "../utility/common/DropdownComponent/DropdownHelper";

const DropdownValueMaster = forwardRef((props, ref) => {
  let formName = "Dropdown Value";
  const [rowData, setRowData] = useState({});
  const [filteredResult, setFilteredResult] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [allData, setAllData] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [action, setAction] = useState("");
  const [show1, setShow1] = useState(false);
  const [data, setdata] = useState("");
  const [reload, setReload] = useState(false);
  const [excelData1, setExcelData] = useState([]);
  const childRef = useRef();

  const tmpcolumnDefs = [
    {
      headerName: "Dropdown Field Name",
      field: "wld_fieldName",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
      flex: 3,
    },
    {
      headerName: "Value",
      field: "wld_dropdownValue",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
      flex: 1
    },
  ];

  const handleEdit = (row) => {
    setAction("Edit");
    setRowData(row);
    setShowForm(true);
  };

  const headerName = (field) => {
    return getHeader_FieldName(field, tmpcolumnDefs, "getHeader");
  };

  const fieldName = (header) => {
    return getHeader_FieldName(header, tmpcolumnDefs, "getField");
  };

  const fetchDropdownData = async () => {
    const result = await getAllDropdown();
    setAllData(result);
    setFilteredResult(result);
  };

  const fetchColumnDefns = () => {
    const result = GlobalColumnDefinations(tmpcolumnDefs);
    result.push({
      headerName: "",
      cellRenderer: actionRenderer,
      width: 250,
      suppressMenu: true,
      sortable: false,
    });
    setColumnDefs(result);
  };

  useEffect(() => {
    fetchDropdownData();
    fetchColumnDefns();
  }, [reload]);

  useImperativeHandle(ref, () => ({
    handleAdd: async () => {
      setAction("Add");
      setShowForm(true);
    },
  }));

  const handleClose = () => {
    setShow1(false);
  };

  const handleGlobalSearch = (text) => {
    childRef.current.setSearch(text.toLowerCase());
  };

  const handleGlobalExport = () => {
    handleExport1(excelData1, "DropdownValueMaster", tmpcolumnDefs);
  };

  const actionRenderer = (params) => {
    return (
      <UnifiedActionRenderer
        actions={["edit", "delete"]}
        selectedData={params}
        handleEditEvent={(params) => handleEdit(params.data)}
        handleDeleteEvent={(params) => {
          setdata(params.data);
          setShow1(true);
          setAction("Delete");
        }}
      />
    );
  };

  const handleDelete = async () => {
    try {
      const result = await deleteDropdownValue(data);
      if (result.status === true) {
        showSuccessToast("Selected Dropdown Value has been Deleted successfully");
        //To get the latest dropdown value list
        await refreshDropdown(data.wld_fieldName);
      } else {
        showWarning("Error!!!, Not able to delete Dropdown Value");
      }
      setReload(!reload);
    } catch (error) {
      showWarning("Error!!!, Not able to delete Dropdown Value");
    } finally {
      setdata("");
      setShow1(false);
    }
  };

  return (
    <Container fluid>
      <ConfirmAlertModal
        action={action}
        handleYes={handleDelete}
        formName={formName}
        show={show1}
        handleClose={handleClose}
      />
      <Row className="RowHeight">
        <Col md={2} sm={12} xs={12} className="ListTitle">
          Dropdown Value List
        </Col>
        <Col>
          <div className="global-search-container">
            <GolbalSearch
              searchplaceholdertext={"Search for Dropdown Field Name, Value"}
              filterFunc={handleGlobalSearch}
            />
            <img
              className="allexport"
              src={ExportIcon}
              onMouseOver={(e) => (e.currentTarget.src = Export_blue)}
              onMouseOut={(e) => (e.currentTarget.src = ExportIcon)}
              alt="ExportIcon"
              onClick={handleGlobalExport}
            />
          </div>
        </Col>
      </Row>
      <GridMaster
        rowDetails={filteredResult}
        colDetails={columnDefs}
        fieldNames={fieldName}
        headerNames={headerName}
        setExcelData={setExcelData}
        ref={childRef}
        paginationPageSize={7}
        pagination={true}
      />
      {showForm && (
        <AddEditDropdownValueMaster
          show={showForm}
          action={action}
          rowdata={rowData}
          onHide={() => setShowForm(false)}
          setReload={setReload}
          reload={reload}
          allRecs={allData}
          backdrop="static"
        />
      )}
      <Toaster />
    </Container>
  );
});

export default DropdownValueMaster;
